import React from 'react'
import PropTypes from 'prop-types'

import Progress from 'antd/lib/progress'
import 'antd/lib/progress/style/css'

import './ProgressComponent.scss'

const ProgressComponent = (props) => {
  return (
    <div className="progress-component antd-component">
      <Progress {...props} />
    </div>
  )
}

ProgressComponent.propTypes = {
  strokeColor: PropTypes.string,
}

ProgressComponent.defaultProps = {
  strokeColor: '#1ec95b',
}

export default ProgressComponent
